import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';

import { transformFieldsName } from '../i18n';

import FormTitle from '../components/setSendData/FormTitle';
import NameAndAccountData from '../components/setSendData/NameAndAccountData';
import BasicData from '../components/setSendData/BasicData';
import CreateFields from '../components/setSendData/CreateFields';
import EmailTemplate from '../components/setSendData/EmailTemplate';
import DownloadReportModal from '../components/setSendData/DownloadReportModal';
import SendTime from '../components/setSendData/SendTime';
import EmailData from '../components/setSendData/EmailData';
import ButtonReportData from '../components/setSendData/ButtonReportData';
import ButtonSendData from '../components/setSendData/ButtonSendData';
import NoAdAccountPage from '../components/setSendData/NoAdAccountPage';

import GoogleCampaignData from '../components/setSendData/google/GoogleCampaignData';
import GoogleFieldsData from '../components/setSendData/google/GoogleFieldsData';

import ModalComponent from '../components/modal/ModalComponent';
import { MODAL_CREATE_REPORT } from '../components/modal/constants';
import Loading from '../components/loading/Loading';
import { SEND_TIME_DATA, handleMailMessageExtra, handleBiweeklyStart } from '../components/setSendData/data/emailConstants';

import {
  INPUT_ERROR_MSG,
  DOWNLOAD_ERROR_MSG,
  checkExcelNaming,
  checkDateRangeForm,
  checkReportForm,
} from '../components/formData/formData';

import { BoxModalAlert } from '../components/customComponent';

import { REPORT_LANGUAGE, getManualTranslation } from '../i18n';

import { requestKey } from '../api/api';
import { apiList, getCancelData } from '../api/callAPI';

import useUser from '../hook/useUser';
import useGlobalStatus from '../hook/useGlobalStatus';
import useCancel from '../hook/useCancel';
import useAllAdAccount from '../hook/useAllAdAccount';
import useGoogleFieldsData from '../hook/useGoogleFieldsData';
import useColorSystem from '../hook/useColorSystem';

import * as basicConstants from '../constants/basic';
import * as urlConstants from '../constants/url';
import * as alertConstants from '../constants/alertMsg';

import {
  excelSheets,
  presetVideoSheets,
  generalData,
  allConversionsData,
  tickAllConversionsData,
  conversionsData,
  tickConversionsData,
  allFixedFields,
  emailBasicFields,
  presetExcelSheets,
  emailTemplateFields
} from '../utils/GoogleFieldsDefined';

import { formatDate, formatDate3, compareAscDate, handleDateRange, formatDate2 } from '../utils/date';
import { scrollToAnchor } from '../utils/commonUtils';


const media = 'GOOGLE';
const i18nMedia = 'Google';
const maxFieldsIndexNumber = 46;
const initCustomFieldsIndexNumber = 100;

//取得自定義指標
const getCustomFields = (currentFields) => {
  const filterCustomFields = _.filter(currentFields, f =>
    (f.type === 'CUSTOM' || f.type === 'FORMAT') && !f.cid
  );
  const customFields = filterCustomFields.map((edition) => {
    return {
      cid: null,
      cidname: null,
      name: edition.name,
      name_en: edition.name,
      expression: edition.expression,
      format: edition.format,
      type: 'CUSTOM',
      indexNumber: edition.indexNumber,
      sheet: edition.sheet,
    };
  })

  return [{
    category: 'custom',
    name: '自定義指標',
    child: customFields
  }]
}

const getSelectedCustomFields = (allCustomData, saveCustomData) => {
  const allFields = allCustomData.map((edition) => {
    return {
      name: edition.name,
      name_en: edition.name,
      expression: edition.id,
      format: 'DEFAULT',
      type: 'CUSTOM',
      sheet: ['menu'],
      cidname: edition.cidname,
      cid: edition.cid,
      indexNumber: edition.indexNumber
    };
  })

  const newFields = _.differenceBy(allFields, saveCustomData, 'expression'); // allFields 有、saveCustomData 沒有的新欄位
  const newAndSaveFields = _.concat(newFields, saveCustomData); // 新欄位 + 儲存的欄位
  const matchFields = _.intersectionBy(newAndSaveFields, allFields, 'expression'); // 篩選掉已被移除的儲存欄位
  const updateFieldsIndex = matchFields.map((edition, index) => {
    return {
      ...edition,
      indexNumber: edition.indexNumber != null ? edition.indexNumber : initCustomFieldsIndexNumber + index
    }
  })
  return updateFieldsIndex;
}


const GoogleCreateData = (props) => {
  const history = useHistory();
  const intl = useIntl();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { currentActiveData, setCurrentActiveData, locale, entryPath, setEntryPath, setModalContent, setIsModalOpen, setModalData, handleAlertMsgSettings } = useGlobalStatus();
  const { cancelData, setCancelData } = useCancel();
  const { allAdAccount } = useAllAdAccount();

  const [currentTab, setCurrentTab] = useState(0);
  const [cidList, setCidList] = useState([]);
  const [selectedAdAccounts, setSelectedAdAccounts] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState([]);

  const [reportName, setReportName] = useState('');
  const [dateRange, setDateRange] = useState({ startSendDate: null, endSendDate: null });
  const [reportDateRange, setReportDateRange] = useState({ startReportDate: null, endReportDate: null });
  const [reportLanguage, setReportLanguage] = useState(currentActiveData.language || REPORT_LANGUAGE.zh);
  const [conversionsType, setConversionsType] = useState("conversions");
  const [sendTimeData, setSendTimeData] = useState(SEND_TIME_DATA);

  const [emailList, setEmailList] = useState([]);
  const [emailString, setEmailString] = useState();
  const [emailTemplateType, setEmailTemplateType] = useState(basicConstants.EMAIL_TEMPLATE_COVERSION_CAMPAIGN);
  const [emailTemplatePrev, setEmailTemplatePrev] = useState({});
  const [emailTemplateCurrent, setEmailTemplateCurrent] = useState({});

  const [excelSheetSelected, setExcelSheetSelected] = useState([]);
  const [allExcelSheetChecked, setAllExcelSheetChecked] = useState(false);
  const [currentSheetName, setCurrentSheetName] = useState("");
  const [currentSheetOrigiName, setCurrentSheetOrigiName] = useState("");
  const [selectedExcelIndex, setSelectedExcelIndex] = useState(null);

  //欄位
  const [
    // googleDefinition,
    // generalData,
    // conversionsData,
    // tickAllConversionsData,
    // tickConversionsData,
    // generalFields,
    // allConversionsFields,
    // conversionsFields,
  ] = useGoogleFieldsData();

  const currentActiveDataWithCustomFields = getCustomFields(currentActiveData.fields);
  const editReportInitFields = _.concat(currentActiveDataWithCustomFields, allFixedFields);

  const [origiCustomData, setOrigiCustomData] = useState([]);
  const [allDisplayFields, setAllDisplayFields] = useState(entryPath.includes('create') ? allFixedFields : editReportInitFields); //畫面顯示分類後的欄位
  const [allUpdatefields, setAllUpdatefields] = useState([]); //控制上傳至伺服器的欄位語言
  const [updateSortFields, setUpdateSortFields] = useState([]); //已選擇的所有欄位排序
  const [selectedGeneralFields, setSelectedGeneralFields] = useState([]); //已選擇的一般欄位(含自訂公式欄位)
  const [selectedConversionsFields, setSelectedConversionsFields] = useState([]); //已選擇的轉換欄位
  const [selectedCustomFields, setSelectedCustomFields] = useState([]); //已選擇的自訂轉換欄
  const [currentSheetSelectFields, setCurrentSheetSelectFields] = useState([]); //點選頁籤顯示該頁籤已選擇的欄位
  const [currenOptionFields, setCurrenOptionFields] = useState(null); //點選修改自訂名稱的欄位

  const [inputErrorMsg, setInputErrorMsg] = useState(INPUT_ERROR_MSG)
  const [downloadInputErrorMsg, setDownloadInputErrorMsg] = useState(DOWNLOAD_ERROR_MSG)
  const [modalName, setModalName] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [downloadOrSend, setDownloadOrSend] = useState('');
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  const getSelectedCidData = (allCidList, selectedCidList) => {
    return _.filter(allCidList, el => _.findIndex(selectedCidList, c => c.adAccountId === el.adAccountId) > -1);
  }

  useEffect(() => {
    const initializeCidList = () => {
      if (allAdAccount) {
        setCidList(allAdAccount.filter((el) => el.media === media));
        setSelectedAdAccounts(
          entryPath.includes('create') ? [] : getSelectedCidData(allAdAccount, currentActiveData.facebookAccounts)
        );
        setIsLoading(false)
      }
    };

    initializeCidList();
  }, [allAdAccount, media, entryPath, currentActiveData])

  //儲存寄送設定
  useEffect(() => {
    if (downloadOrSend === 'downloadData') {
      return;
    } else if (downloadOrSend === 'sendData') {
      handleStoreReport();
    }
  }, [downloadOrSend])

  //重新整理後返回媒體選單
  useEffect(() => {
    if (entryPath === '') {
      history.push(urlConstants.PAGE_MEDIA_MENU);
      setIsModalOpen(false);
    }
  }, [entryPath])

  //改變帳號時清空廣告活動、自訂欄
  useEffect(() => {
    setCampaignList([]);
    setSelectedCampaign([]);
    setCurrentSheetName("");
    setSelectedExcelIndex(null);
    setOrigiCustomData([]);
    setSelectedCustomFields([]);
    setCurrentSheetSelectFields([]);
    setCurrenOptionFields(null);

    if (entryPath === urlConstants.PAGE_GOOGLE_EDIT_DATA) {
      const filterCustomFields = currentActiveData.fields.filter((el) => el.cid !== null);

      //若設定過自訂欄，進入編輯頁會自動更新自訂欄
      if (selectedAdAccounts.length !== 0 && filterCustomFields.length !== 0) {
        fetchCustomData('auto');
      }

    }
  }, [selectedAdAccounts])

  const handleGetCustomFields = () => {
    if (selectedCustomFields.length > 0) return;
    setCurrentSheetName("");
    setSelectedExcelIndex(null);
    setOrigiCustomData([]);
    setSelectedCustomFields([]);
    setCurrentSheetSelectFields([]);
    setCurrenOptionFields(null);
    fetchCustomData('click');
  }

  const fetchCustomData = (type) => {
    setIsLoading(true);
    const adAccountId = selectedAdAccounts.map(el => el.adAccountId);

    apiList.googleCustomFields({
      cid: adAccountId.toString()
    })
      .then(res => {
        if (res.status === 200) {
          const resData = _.unionBy(res.data.result, 'id');
          const isEmptyData = resData === null || !resData.length;

          if (entryPath.includes('create')) {
            handleCreateCustom(resData, isEmptyData);
          } else if (entryPath.includes('edit')) {
            handleEditCustom(resData, isEmptyData, type);
          }

          setIsLoading(false);

        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          alert(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })
  }

  const handleCreateCustom = (resData, isEmptyData) => {
    setOrigiCustomData(isEmptyData ? [] : resData);
    setSelectedCustomFields(isEmptyData ? [] : customFieldsData);
    setModalContent(isEmptyData ? { ...MODAL_CREATE_REPORT['checkNoCustomfields'], media: media } : { ...MODAL_CREATE_REPORT['checkImportCustomfields'], media: media });
    setIsModalOpen(true);
  }

  const handleEditCustom = (resData, isEmptyData, type) => {
    const filterCustomFields = currentActiveData.fields.filter((el) => el.cid !== null);

    setOrigiCustomData(isEmptyData ? [] : resData);
    setSelectedCustomFields(isEmptyData ? [] : getSelectedCustomFields(resData, filterCustomFields));

    if (type === 'click') {
      setModalContent(isEmptyData ? { ...MODAL_CREATE_REPORT['checkNoCustomfields'], media: media } : { ...MODAL_CREATE_REPORT['checkImportCustomfields'], media: media });
      setIsModalOpen(true);
    }
  }

  //自訂欄(顯示分類)
  const customDisplayFields = Array.from(new Set(origiCustomData
    .map((s) => s.cidname)))
    .map((lab, index) => {
      return {
        category: lab,
        name: "自訂轉換欄",
        child: origiCustomData.filter((item) => item.cidname === lab)
          .map((edition, index) => {
            return {
              name: edition.name,
              name_en: edition.name,
              expression: edition.id,
              format: 'DEFAULT',
              type: 'CUSTOM',
              sheet: ['menu'],
              cidname: edition.cidname,
              cid: edition.cid,
              indexNumber: maxFieldsIndexNumber + 1 + index
            }
          })
      }
    })

  //自訂欄(回傳格式)
  const customFieldsData = origiCustomData.map((edition, index) => {
    return {
      name: edition.name,
      name_en: edition.name,
      expression: edition.id,
      format: 'DEFAULT',
      type: 'CUSTOM',
      sheet: ['menu'],
      cidname: edition.cidname,
      cid: edition.cid,
      indexNumber: maxFieldsIndexNumber + 1 + index
    }
  })

  //廣告活動(回傳格式)
  const campaignData = selectedCampaign.map((edition) => {
    return {
      cid: edition.cid,
      cidname: edition.cidname,
      id: edition.id,
      name: edition.name
    }
  })

  useEffect(() => {
    changeDisplayCustomFields();
  }, [origiCustomData]);

  const changeDisplayCustomFields = () => {
    const cloneAllDisplayFields = JSON.parse(JSON.stringify(allDisplayFields));
    const clearCustomFields = cloneAllDisplayFields.filter(el => el.name !== '自訂轉換欄');
    const addCustomConversions = customDisplayFields.concat(clearCustomFields);

    setAllDisplayFields(addCustomConversions);
  }

  const changeSelectedCustomFields = () => {
    setSelectedCustomFields(customFieldsData);
  }

  const handleSortAllFields = (allFields) => {
    const updateFields = allFields && allFields
      .sort((a, b) => {
        if (a.indexNumber === null) return 1;
        if (b.indexNumber === null) return -1;
        return a.indexNumber - b.indexNumber;
      })
      .map((field, index) => ({
        ...field,
        indexNumber: field.indexNumber != null ? index : allFields?.length + index
      }))

    return updateFields;
  }

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name === 'reportName') {
      setReportName(value);
    }
    if (name === 'emailString') {
      setEmailString(value);
    }
  }

  const handleModalDetail = (type) => {
    setOpenModal(true);

    if (type === 'create_custom_metric') {
      setModalName('create_custom_metric');
    } else if (type === 'sort_metric') {
      setModalName('sort_metric');
    }
  }

  //新增自定義指標
  const addCustomFields = (newFields, matchFields) => {
    const allSheet = presetExcelSheets;
    newFields.sheet = allSheet;

    const updateFields = (origiFields, fieldsType) => {
      const cloneFields = JSON.parse(JSON.stringify(origiFields));
      const index = cloneFields.findIndex(el => el.expression === newFields.expression);

      // 顯示欄位新增自定義指標
      if (fieldsType === 'display') {
        const categoryIndex = cloneFields.findIndex(item => item.category === 'custom');

        if (categoryIndex !== -1) {
          const childIndex = cloneFields[categoryIndex].child.findIndex(item => item.expression === newFields.expression);
          //已存在的自定義指標就覆蓋，否則新增一欄
          childIndex !== -1 ? cloneFields[categoryIndex].child[childIndex] = newFields : cloneFields[categoryIndex].child.push(newFields);
        } else {
          cloneFields.unshift({
            category: 'custom',
            name: '自定義指標',
            child: [newFields]
          })
        }
      }

      // 已選欄位新增自定義指標
      if (fieldsType === 'general') {
        index !== -1 ? cloneFields[index] = newFields : cloneFields.push(newFields);
      }

      // 有設公式的指標在所有頁籤自動打勾 (一般欄位、自訂轉換欄都會影響)
      const updateFields = cloneFields.map(field => {
        if (matchFields.includes(field.expression)) {
          field.sheet = allSheet
        }
        return field;
      })

      return updateFields;
    }

    setAllDisplayFields(updateFields(allDisplayFields, 'display'));
    setSelectedGeneralFields(updateFields(selectedGeneralFields, 'general'));
    setSelectedCustomFields(updateFields(selectedCustomFields, 'conversions'));
    setCurrentSheetName("");
    setSelectedExcelIndex(null);
  }

  const validateReportForm = (isDownload) => {
    const formData = {
      reportName,
      fbAdAccounts: selectedAdAccounts,
      excelSheet: excelSheetSelected,
      selectFields: _.concat(selectedGeneralFields, selectedConversionsFields, selectedCustomFields),
      optionFieldName: _.concat(selectedGeneralFields, selectedConversionsFields, selectedCustomFields),
      reportType: sendTimeData,
      emailList,
      emailTemplate: emailTemplateCurrent,
      emailTemplateType,
      dateRange,
      isDownload
    };

    return checkReportForm(formData, media);
  }

  const clickDownloadReport = () => {
    setDownloadOrSend('downloadData');
    const { errorMsg, isErrorStatue } = validateReportForm(true);
    setInputErrorMsg({ ...errorMsg, reportDateRange: '' });

    if (isErrorStatue) {
      if (errorMsg.reportName || errorMsg.fbAdAccounts) {
        scrollToAnchor('scrollTop');
      }
      return;
    }

    setModalName('setting_report_dateRange');
    setModalContent({ ...MODAL_CREATE_REPORT['chooseSaveReport'], media: media });
  }

  const clickUpdateReport = () => {
    if (downloadOrSend === 'downloadData' || downloadOrSend === '') {
      setDownloadOrSend('sendData');
    } else if (downloadOrSend === 'sendData') {
      handleStoreReport();
    }
  }

  const prepareReportData = () => {
    const formatDateIfNotNull = date => date !== null ? formatDate(date) : null;
    const localizedFields = transformFieldsName(media, _.concat(selectedGeneralFields, selectedConversionsFields, selectedCustomFields), reportLanguage, intl);
    const sortFields = handleSortAllFields(localizedFields);

    return {
      "weeklyReportName": reportName,
      "startSendDate": null,
      "endSendDate": null,
      "sendDay": sendTimeData.weekday + 1,
      "sendTime": basicConstants.HOUR_LIST[sendTimeData.weektime],
      "monthly": sendTimeData.monthday + 1,
      "biweekly_day": sendTimeData.biWeekDay + 1,
      "biweekly_start": sendTimeData.reportType.includes('2') ? handleBiweeklyStart(currentActiveData, sendTimeData) : null,
      "reportType": sendTimeData.reportType.join(','),
      "facebookAdAccountIds": selectedAdAccounts.map(el => el.adAccountId),
      "toAddresses": emailList.filter(el => el !== ""),
      "mailMessageType": emailTemplateType,
      "mailMessageExtra": handleMailMessageExtra(media, emailTemplateType, emailTemplateCurrent, reportLanguage, intl),
      "excelSheets": excelSheetSelected,
      "fields": sortFields,
      "startReportDate": formatDateIfNotNull(reportDateRange.startReportDate),
      "endReportDate": formatDateIfNotNull(reportDateRange.endReportDate),
      "campaignList": campaignData.map((el) => el.id),
      "language": reportLanguage,
      "conversionsType": conversionsType,
    }
  }

  const handleChooseSaveReport = (saveSettings) => {
    const errorMsg = checkDateRangeForm(reportDateRange);
    setInputErrorMsg({ reportDateRange: errorMsg });
    if (errorMsg) return;

    const storeReportData = prepareReportData();

    if (saveSettings === 'saveReport') {
      handleDownloadReport(storeReportData);
    } else {
      setModalContent({ ...MODAL_CREATE_REPORT['processingDownloadReport'], media: media });
      setIsModalOpen(true);
      setModalName('');
      downloadExternalReport(storeReportData);
    }
  }

  const handleDownloadReport = (storeReportData) => {
    if (entryPath.includes("create")) {
      createReport(storeReportData);
    } else if (entryPath.includes("edit")) {
      updateReport(storeReportData);
    }
  }

  const handleStoreReport = () => {
    const { isTab1Error, isTab2Error, errorMsg, isErrorStatue } = validateReportForm(false);
    setInputErrorMsg(errorMsg);

    if (isTab1Error) {
      scrollToAnchor('scrollTop');
      setCurrentTab(0);
    } else if (isTab2Error) {
      scrollToAnchor('scrollTop');
      setCurrentTab(1);
    }

    if (isErrorStatue) return;

    const storeReportData = prepareReportData();

    if (entryPath.includes("create")) {
      createReport(storeReportData);
    } else if (entryPath.includes("edit")) {
      updateReport(storeReportData);
    }
  }

  //1.createReport
  const createReport = (createReportData) => {
    setModalName('');
    setIsLoading(true);

    apiList.createGoogleReport(createReportData)
      .then(res => {
        if (res.status === 200) {
          if (downloadOrSend === 'downloadData') {
            getSendList();
          } else if (downloadOrSend === 'sendData') {
            setIsLoading(false);
            setModalName('alert');
            setTimeout(() => {
              setModalName('');
              history.push(urlConstants.PAGE_GOOGLE_SEND_LIST);
            }, 2000)
          }

        } else if (res.status === 500 || res.status === 400) {
          scrollToAnchor('scrollTop');
          alert(alertConstants.ERROR_CUSTOM_EXPRESSION);
          setIsLoading(false);
        } else {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        }
      })
  }

  //取得寄送清單 getReportList 
  const fetchData = (cancelToken) => {
    let result;

    result = apiList.getGoogleReportList({
      page: 0,
      size: 10,
      sort: null,
      order: null
    }, cancelToken)

    result.then(res => {
      if (res.message && res.message === alertConstants.CANCEL_REQUEST) return;

      if (res.status === 200) {
        confirmReport(res.data.result.content);
      } else if (res.status === 401) {
        setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
        setUserData(false);
        history.push(urlConstants.PAGE_LOGIN);
      } else {
        alert(alertConstants.ERROR_SYSTEMCONNECT);
        history.push(urlConstants.PAGE_GOOGLE_SEND_LIST)
      }
    })
  }

  //取得寄送清單
  const getSendList = () => {
    let call;

    if (cancelData) {
      cancelData.cancel(alertConstants.CANCEL_REQUEST);
    }

    call = getCancelData();
    setCancelData(call);

    fetchData(call.token);
  }

  //確認匯出報表
  const confirmReport = (sendList) => {
    setIsProcessing('downloadReport');

    if (entryPath === urlConstants.PAGE_GOOGLE_CREATE_DATA) {
      setCurrentActiveData(sendList[0]);
    }
    setModalContent({ ...MODAL_CREATE_REPORT['confirmDownloadReport'], media: media });
    setModalData({ reportName });
    setIsModalOpen(true);
    setIsProcessing(false);
    setIsLoading(false);
  }

  //下載報表excel
  const downloadReport = () => {
    setIsProcessing('downloadReport');
    const reportMedia = getManualTranslation('common.title.googleReport', reportLanguage);
    const updatedReportName = checkExcelNaming(reportName);
    const dataRange = handleDateRange(reportDateRange.startReportDate, reportDateRange.endReportDate);
    const fileName = `${reportMedia}${updatedReportName}_${dataRange}.xlsx`;

    apiList.downloadGoogleReport({
      weeklyReportId: currentActiveData.weeklyReportId,
      start_date: formatDate2(reportDateRange.startReportDate),
      end_date: formatDate2(reportDateRange.endReportDate)
    })
      .then(res => {
        if (res.status === 201) {
          const contentType = res.headers['content-type'];
          const file = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          setTimeout(() => {
            setIsModalOpen(false);
            setIsProcessing(false);
            history.push(urlConstants.PAGE_GOOGLE_SEND_LIST)
          }, 2000)
        } else if (res.status === 401) {
          setIsModalOpen(false);
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else if (res.status === 404) {
          setIsProcessing(false);
          setModalContent({ ...MODAL_CREATE_REPORT['downloadReportNoData'], media: media });
          setIsModalOpen(true);
        } else {
          setIsModalOpen(false);
          setIsProcessing(false);
          alert(alertConstants.ERROR_SYSTEMCONNECT);
          history.push(urlConstants.PAGE_GOOGLE_SEND_LIST)
        }
      })
  }

  const downloadExternalReport = (updateReportData) => {
    setIsProcessing('downloadReport');
    const reportMedia = getManualTranslation('common.title.googleReport', reportLanguage);
    const updatedReportName = checkExcelNaming(reportName);
    const dataRange = handleDateRange(reportDateRange.startReportDate, reportDateRange.endReportDate);
    const fileName = `${reportMedia}${updatedReportName}_${dataRange}.xlsx`;

    const params = {
      requestKey: requestKey,
      startDate: formatDate3(reportDateRange.startReportDate),
      endDate: formatDate3(reportDateRange.endReportDate)
    }

    apiList.downloadGoogleExternalReport({ data: updateReportData, config: params })
      .then(res => {
        if (res.status === 201) {
          const contentType = res.headers['content-type'];
          const file = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(file);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          setIsModalOpen(false);
          setTimeout(() => {
            setIsProcessing(false);
            history.push(urlConstants.PAGE_GOOGLE_SEND_LIST)
          }, 2000)
        } else if (res.status === 401) {
          setIsModalOpen(false);
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else if (res.status === 404) {
          setIsProcessing(false);
          setModalContent({ ...MODAL_CREATE_REPORT['downloadReportNoData'], media: media });
          setIsModalOpen(true);
        } else {
          setIsModalOpen(false);
          setIsProcessing(false);
          handleAlertMsgSettings(true, { type: alertConstants.ALERT_TYPE.ERROR, msg: `${alertConstants.ERROR_SYSTEMCONNECT} ${res.status}` });
          history.push(urlConstants.PAGE_GOOGLE_SEND_LIST)
        }
      })
  }

  //2.updateReport
  const updateReport = (updateReportData) => {
    setModalName('');
    setIsLoading(true);

    apiList.updateGoogleReport({ data: updateReportData, config: { weeklyReportId: currentActiveData.weeklyReportId } })
      .then(res => {
        if (res.status === 200) {
          setIsLoading(false);
          if (downloadOrSend === 'downloadData') {
            setModalContent({ ...MODAL_CREATE_REPORT['confirmDownloadReport'], media: media });
            setModalData({ reportName });
            setIsModalOpen(true);

          } else if (downloadOrSend === 'sendData') {
            setModalName('alert');
            setTimeout(() => {
              setModalName('');
              history.push(urlConstants.PAGE_GOOGLE_SEND_LIST);
            }, 2000)
          }

        } else if (res.status === 500 || res.status === 400) {
          scrollToAnchor('scrollTop');
          alert(alertConstants.ERROR_CUSTOM_EXPRESSION);
          setIsLoading(false);
        } else {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        }
      })
  }

  const handleModalSubmit = (data, type) => {
    switch (type) {
      case 'confirm_download_report':
        downloadReport();
        break;
      case 'download_report_no_data':
        setIsModalOpen(false);
        setEntryPath(urlConstants.PAGE_GOOGLE_EDIT_DATA);
        break;
      case 'check_import_customfields':
        changeSelectedCustomFields();
        setIsModalOpen(false);
        break;
      case 'check_no_customfields':
      case 'check_import_campaign':
      case 'check_no_campaign':
        setIsModalOpen(false);
        break;
      default:
        break;
    }
  }

  // console.log('google_all_fields', _.concat(selectedGeneralFields, selectedConversionsFields, selectedCustomFields));

  return (
    <>
      {
        userData.scopes.includes(basicConstants.AUTH_EDIT_REPORT) &&
        <>
          {/* 置頂錨點 */}
          <Box
            id="scrollTop"
            sx={{
              width: { sm: '100%', md: '80%', lg: '70%' },
              margin: '0 auto 60px'
            }}
          >
            {
              cidList.length > 0 &&
              <>
                <FormTitle
                  media={i18nMedia}
                  currentTab={currentTab}
                  mainColor={mainColor}
                  setCurrentTab={setCurrentTab}
                />

                <Box sx={{ overflow: 'hidden' }}>
                  <Box
                    sx={{
                      position: 'relative',
                      top: 0,
                      left: `-${currentTab * 100}%`,
                      display: 'flex',
                      justifyContent: 'flex-start',
                      width: '200%',
                      transition: 'left .5s'
                    }}
                  >
                    <Box id="basicData" sx={{ width: '100%', padding: '0 4px' }}>
                      <NameAndAccountData
                        media='Google'
                        cidList={cidList}
                        selectedAdAccounts={selectedAdAccounts}
                        setSelectedAdAccounts={setSelectedAdAccounts}
                        reportName={reportName}
                        setReportName={setReportName}
                        handleInput={handleInput}
                        inputErrorMsg={inputErrorMsg}
                      />

                      <GoogleCampaignData
                        media={media}
                        selectedAdAccounts={selectedAdAccounts}
                        campaignList={campaignList}
                        setCampaignList={setCampaignList}
                        selectedCampaign={selectedCampaign}
                        setSelectedCampaign={setSelectedCampaign}
                        setIsLoading={setIsLoading}
                      />

                      <BasicData
                        media={media}
                        reportLanguage={reportLanguage}
                        setReportLanguage={setReportLanguage}
                        conversionsType={conversionsType}
                        setConversionsType={setConversionsType}
                        setCurrentSheetName={setCurrentSheetName}
                        setCurrentSheetOrigiName={setCurrentSheetOrigiName}
                        setSelectedExcelIndex={setSelectedExcelIndex}
                        setSelectedConversionsFields={setSelectedConversionsFields}
                        tickAllConversionsData={tickAllConversionsData}
                        tickConversionsData={tickConversionsData}
                        conversionsData={conversionsData}
                      />

                      <GoogleFieldsData
                        selectedAdAccounts={selectedAdAccounts}
                        entryPath={entryPath}
                        excelSheets={excelSheets}
                        excelSheetSelected={excelSheetSelected}
                        currentSheetName={currentSheetName}
                        currentSheetOrigiName={currentSheetOrigiName}
                        setCurrentSheetOrigiName={setCurrentSheetOrigiName}
                        selectedExcelIndex={selectedExcelIndex}
                        setSelectedExcelIndex={setSelectedExcelIndex}
                        setExcelSheetSelected={setExcelSheetSelected}
                        setAllExcelSheetChecked={setAllExcelSheetChecked}
                        setCurrentSheetName={setCurrentSheetName}
                        handleGetCustomFields={handleGetCustomFields}
                        handleModalDetail={handleModalDetail}
                        inputErrorMsg={inputErrorMsg}
                        downloadInputErrorMsg={downloadInputErrorMsg}
                        reportLanguage={reportLanguage}
                        setReportLanguage={setReportLanguage}
                        conversionsType={conversionsType}
                        allDisplayFields={allDisplayFields}
                        setAllDisplayFields={setAllDisplayFields}
                        updateSortFields={updateSortFields}
                        setUpdateSortFields={setUpdateSortFields}
                        currentSheetSelectFields={currentSheetSelectFields}
                        setCurrentSheetSelectFields={setCurrentSheetSelectFields}
                        currenOptionFields={currenOptionFields}
                        setCurrenOptionFields={setCurrenOptionFields}
                        selectedGeneralFields={selectedGeneralFields}
                        setSelectedGeneralFields={setSelectedGeneralFields}
                        selectedConversionsFields={selectedConversionsFields}
                        setSelectedConversionsFields={setSelectedConversionsFields}
                        selectedCustomFields={selectedCustomFields}
                        setSelectedCustomFields={setSelectedCustomFields}
                        setOrigiCustomData={setOrigiCustomData}
                        tickAllConversionsData={tickAllConversionsData}
                        tickConversionsData={tickConversionsData}
                        conversionsData={conversionsData}
                        allExcelSheetChecked={allExcelSheetChecked}
                      />

                      <ButtonReportData
                        id="scrollDown"
                        colorSystem={colorMedia}
                        clickDownloadReport={clickDownloadReport}
                        setCurrentTab={setCurrentTab}
                        scrollToAnchor={scrollToAnchor}
                      />

                    </Box>

                    <Box id="pagesAndFields" sx={{ width: '100%', padding: '0 4px' }}>
                      <SendTime
                        media={media}
                        sendTimeData={sendTimeData}
                        setSendTimeData={setSendTimeData}
                        inputErrorMsg={inputErrorMsg}
                      />

                      <EmailData
                        media={media}
                        emailList={emailList}
                        setEmailList={setEmailList}
                        emailString={emailString}
                        setEmailString={setEmailString}
                        EmailTemplate={EmailTemplate}
                        emailTemplateCurrent={emailTemplateCurrent}
                        setEmailTemplateCurrent={setEmailTemplateCurrent}
                        emailTemplatePrev={emailTemplatePrev}
                        setEmailTemplatePrev={setEmailTemplatePrev}
                        emailTemplateType={emailTemplateType}
                        setEmailTemplateType={setEmailTemplateType}
                        inputErrorMsg={inputErrorMsg}
                        setInputErrorMsg={setInputErrorMsg}
                        handleInput={handleInput}
                        optionalFields={emailTemplateFields}
                        selectedCampaign={selectedCampaign}
                      />

                      <ButtonSendData
                        colorSystem={colorMedia}
                        setCurrentTab={setCurrentTab}
                        clickUpdateReport={clickUpdateReport}
                        url={urlConstants.PAGE_GOOGLE_SEND_LIST}
                      />

                    </Box>
                  </Box>
                </Box>
              </>
            }
          </Box>
          {
            cidList.length === 0 && !isLoading && entryPath === urlConstants.PAGE_GOOGLE_CREATE_DATA &&
            <NoAdAccountPage
              colorSystem={colorMedia}
              setEntryPath={setEntryPath}
            />
          }
          {
            modalName === 'alert' &&
            <Modal open={modalName === 'alert'} >
              <BoxModalAlert>
                <Typography textAlign="center"><FormattedMessage id="createData.modal.saveReport" /></Typography>
                <Typography textAlign="center" sx={{ color: mainColor }}>{reportName}</Typography>
              </BoxModalAlert>
            </Modal>
          }
          {
            modalName === 'create_custom_metric' &&
            <CreateFields
              media={media}
              optionalFields={allDisplayFields}
              open={modalName === 'create_custom_metric'}
              handleClose={() => setModalName(false)}
              handleSave={addCustomFields}
              reportLanguage={reportLanguage}
            />
          }
          {/* 下載報表走期 */}
          {
            modalName === 'setting_report_dateRange' &&
            <DownloadReportModal
              media={media}
              open={modalName === 'setting_report_dateRange'}
              reportDateRange={reportDateRange}
              setReportDateRange={setReportDateRange}
              inputErrorMsg={inputErrorMsg}
              isLoading={isProcessing}
              handleClose={() => setModalName(false)}
              handleChooseSaveReport={handleChooseSaveReport}
            />
          }
          <ModalComponent
            isLoading={isProcessing}
            handleModalSubmit={handleModalSubmit}
          />
        </>
      }
      <Loading isLoading={isLoading} content={alertConstants.TIP_DATA_LOADING} />
    </>
  )
}

export default GoogleCreateData;